import script from "./history.vue?vue&type=script&setup=true&lang=js"
export * from "./history.vue?vue&type=script&setup=true&lang=js"

import "./history.vue?vue&type=style&index=0&id=17af70a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17af70a6"]])

export default __exports__